import { type AxiosInstance } from 'axios'
import { Cached } from '@coris-ts/helpers/utilities'
import { KeywordFlaggingApiDataSource } from './data/api/keyword-flagging.api-datasource'
import { type KeywordFlaggingDataSource } from './data/keyword-flagging.datasource'
import { GetKeywordListsInteractor } from './domain/interactors/get-keyword-lists.interactor'
import { GetKeywordListInteractor } from './domain/interactors/get-keyword-list.interactor'
import { SaveKeywordListInteractor } from './domain/interactors/save-keyword-list.interactor'
import { DeleteKeywordListInteractor } from './domain/interactors/delete-keyword-list.interactor'

export interface KeywordFlaggingComponent {
  provideGetKeywordLists: () => GetKeywordListsInteractor
  provideGetKeywordList: () => GetKeywordListInteractor
  provideSaveKeywordList: () => SaveKeywordListInteractor
  provideDeleteKeywordList: () => DeleteKeywordListInteractor
}

export class KeywordFlaggingDefaultModule implements KeywordFlaggingComponent {
  constructor(
    private readonly baseUrl: string,
    private readonly axios: AxiosInstance,
    private readonly getOrganizationSlug: () => string | undefined
  ) {}

  @Cached()
  private getDataSource(): KeywordFlaggingDataSource {
    return new KeywordFlaggingApiDataSource(this.baseUrl, this.axios, this.getOrganizationSlug)
  }

  public provideGetKeywordLists(): GetKeywordListsInteractor {
    return new GetKeywordListsInteractor(this.getDataSource())
  }

  public provideGetKeywordList(): GetKeywordListInteractor {
    return new GetKeywordListInteractor(this.getDataSource())
  }

  public provideSaveKeywordList(): SaveKeywordListInteractor {
    return new SaveKeywordListInteractor(this.getDataSource())
  }

  public provideDeleteKeywordList(): DeleteKeywordListInteractor {
    return new DeleteKeywordListInteractor(this.getDataSource())
  }
}
